// extracted by mini-css-extract-plugin
module.exports = {"hidden":"hidden--CtBeE2gEbn11ZMj0dkyM"};